import React from "react";
import { Input, Label } from "reactstrap";
import { Controller } from "react-hook-form";
import { useLocalizedText } from "../../../../utils/hooks/useLocalizedText";

const PermissionCheckbox = ({
  permission,
  isSelected,
  onChange,
  control,
  mode = "form",
  className = "d-flex align-items-center gap-2",
}) => {
  const checkboxId = `permission_${permission?.id}`;
  const { getLocalizedText } = useLocalizedText();

  if (mode === "display") {
    return (
      <div className={className}>
        <Input
          id={checkboxId}
          type="checkbox"
          checked={isSelected}
          disabled
          readOnly
        />
        <Label for={checkboxId} className="mb-0">
          {getLocalizedText(
            permission.display_name_ar,
            permission.display_name_en
          )}
        </Label>
      </div>
    );
  }

  return (
    <div className={className}>
      {control ? (
        <Controller
          name={`permission_${permission?.id}`}
          control={control}
          render={({ field }) => (
            <Input
              id={checkboxId}
              type="checkbox"
              checked={isSelected}
              onChange={(e) => onChange(e.target.checked)}
            />
          )}
        />
      ) : (
        <Input
          id={checkboxId}
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onChange(e.target.checked)}
        />
      )}
      <Label for={checkboxId} className="mb-0">
        {getLocalizedText(
          permission.display_name_ar,
          permission.display_name_en
        )}
      </Label>
    </div>
  );
};

export default PermissionCheckbox;
